// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__fCZB7","consentsList":"PatientConsents_consentsList__3dJry","consentsListEmpty":"PatientConsents_consentsListEmpty__349FK"};